<template>
  <!-- 企业注册 -->
  <div class="login-container flex-b-r">
    <div class="login-body">
      <div class="title">
        侦迹云企业注册
        <p v-if="Review != 1 && Review != 3" @click="handelSkipFirm" style="cursor: pointer;">
          全部企业
        </p>
      </div>
      <!-- 右侧反馈 客服 -->
      <div class="right_btn">
        <IndexRight :skipLoginCheck="true" :hideCustomerService="true" :isCompanyRegister="true"></IndexRight>
      </div>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <!-- 表单区 -->
        <div class="firmSign-Body" v-if="Review != 1 && Review != 3">
          <!-- 右侧大div -->
          <div class="firmSign">
            <el-form-item prop="name">
              <div class="input-box">
                <p><span style="color: red">*</span>企业名称：</p>
                <el-input
                  v-model="ruleForm.name"
                  placeholder="请输入企业名称"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item>
              <div class="input-box">
                <p><span style="color: red">*</span>企业类型：</p>
                <div class="Selection">
                  <p
                    v-for="(item, index) in TypeArr"
                    :key="index"
                    :class="ruleForm.type == item.id ? 'Select-p' : ''"
                    @click="handelType(item)"
                  >
                    {{ item.Options }}
                  </p>
                </div>
              </div>
            </el-form-item>
            <el-form-item prop="creditCode">
              <div class="input-box">
                <p><span style="color: red">*</span>企业统一社会信用代码：</p>
                <el-input
                  v-model="ruleForm.creditCode"
                  placeholder="请输入企业统一社会信用代码"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item prop="legalPersonName">
              <div class="input-box">
                <p><span style="color: red">*</span>法定代表人(负责人)：</p>
                <el-input
                  v-model="ruleForm.legalPersonName"
                  placeholder="请输入法定代表人(负责人)姓名"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item prop="idCard">
              <div class="input-box">
                <p><span style="color: red">*</span>法人身份证号：</p>
                <el-input
                  v-model="ruleForm.idCard"
                  placeholder="请输入法人身份证号"
                ></el-input>
              </div>
            </el-form-item>
            <!-- <el-form-item prop="companyRegisterAddress">
              <div class="input-box">
                <p><span style="color: red">*</span>企业地址：</p>
                <el-input
                  v-model="ruleForm.companyRegisterAddress"
                  placeholder="请输入企业地址"
                ></el-input>
              </div>
            </el-form-item> -->
          </div>
          <!-- 右侧大div -->
          <div class="firmSign firmSign-left">
            <!-- <el-form-item>
              <div class="avatar_box">
                <p>头像：</p>
                <Avatar
                  @handleAvatarTxUrl="handleAvatarTxUrl"
                  :avatarArr="avatarArr"
                ></Avatar>
              </div>
            </el-form-item> -->
            <el-form-item prop="companyRegisterAddress">
              <div class="avatar_box">
                <p><span style="color: red">*</span>企业地址：</p>
                <el-input
                  v-model="ruleForm.companyRegisterAddress"
                  placeholder="请输入企业地址"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item prop="mail">
              <div class="avatar_box">
                <p><span style="color: red">*</span>邮箱验证：</p>
                <el-input
                  v-model="ruleForm.mail"
                  placeholder="请输入个人邮箱"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item prop="authCode">
              <div class="avatar_box">
                <p></p>
                <el-input
                  v-model="ruleForm.authCode"
                  placeholder="请输入验证码"
                ></el-input>
                <p
                  class="Send-p firm-clickable"
                  @click="second == 60 ? Countdown('ruleForm') : ''"
                >
                  {{
                    second === totalSecond && sendNum == 0
                      ? "发送验证码"
                      : second === totalSecond && sendNum != 0
                      ? "再次发送验证码"
                      : second + `s`
                  }}
                </p>
              </div>
            </el-form-item>
            <el-form-item>
              <div class="avatar_box">
                <p>推荐码：</p>
                <el-input
                  v-model="ruleForm.useRecommendCode"
                  placeholder="请输入推荐码(推荐人/企业的唯一ID)"
                ></el-input>
              </div>
            </el-form-item>
          </div>
        </div>
        <div class="firmSign-Body" v-if="Review == 1">
          <div class="firmSign-BodyP">
            <img
              v-if="resData.status == 1"
              src="../../assets/imgs/img/geren-SVG/by.svg"
              style="
                width: 100px;
                height: 100px;
                margin-top: 50px;
                margin-bottom: 50px;
              "
              alt=""
            />
            <img
              v-if="resData.status == 0"
              src="../../assets/imgs/img/geren-SVG/UnderReview.svg"
              alt=""
            />
            <p class="Result-p">{{ ReviewStr }}</p>
          </div>
        </div>
        <!-- 审核失败 -->
        <div class="firmSign-Body" v-if="Review == 3">
          <div class="firmSign-BodyP">
            <img src="../../assets/imgs/img/geren-SVG/NotThrough.svg" alt="" />
            <p class="Result-p">审核不通过</p>
            <p class="Reason-p">{{ rejectReason }}</p>
          </div>
        </div>
      </el-form>
      <!-- 按钮 -->
      <div class="SignBtn">
        <div class="btn-box">
          <p class="firm-clickable" @click="handelReturn">返回</p>
          <p class="firm-clickable" @click="Review = 4" v-if="Review == 3">重新申请</p>
          <p class="firm-clickable" @click="handelSkipHomepage('ruleForm')" v-if="Review == 2">注册</p>
          <p class="firm-clickable" @click="handelSkipHomepage('ruleForm')" v-if="Review == 4">
            重新申请
          </p>
        </div>
      </div>
    </div>
    <div class="BaseMap"></div>
  </div>
</template>

<script>
// 封装的表单验证
import { vxRule } from "../../../untils/FormValidation/validate-form";
// 引入头像组件
import Avatar from "../../components/AvatarToken.vue";
// 引入右侧反馈组件
import IndexRight from "../../components/IndexRight.vue";
import { mapActions } from "vuex";
import {
  postSendAuthCode, // 发送短信，邮箱验证码
  getSysDefaultUserImg,
  companyRegisterAuditRecord, //获取企业注册审核情况
} from "../../assets/api/index";
import {
  companyRegister, // 企业注册
} from "../../assets/api/firm/firmLogin";
export default {
  // 组件名称
  name: "firmsign",
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {
    // Avatar,
    IndexRight
  },
  // 组件状态值
  data() {
    return {
      TypeArr: [
        { Options: "有限公司", id: "0" },
        { Options: "个体户", id: "1" },
        { Options: "子公司", id: "2" },
        { Options: "分公司", id: "3" },
        { Options: "其他", id: "4" },
      ], // 公司类型选择

      totalSecond: 60, // 总秒数
      second: 60, // 倒计时的秒数
      timer: null, // 定时器 id
      sendNum: "0", // 发送次数首次叫获取验证码之后叫再次发送验证码
      ruleForm: {
        mobile: "", //登录手机号
        name: "", // 企业名称
        type: "0", //公司类型 0企业 1个体户 2社会团队
        creditCode: "", // 统一代码
        legalPersonName: "", //法人名
        idCard: "", //身份证号
        // logoImg: "", // 企业头像
        mail: "", // 邮箱
        authCode: "", // 邮箱验证码
        useRecommendCode: "", // 推荐码
        companyRegisterAddress: "", //企业地址
      }, // v-mode
      rules: {
        name: vxRule(true, "", ["blur", "change"], "请输入企业名称"),

        authCode: vxRule(true, "", ["blur", "change"], "请输入验证码"),
        companyRegisterAddress: vxRule(true, "", ["blur", "change"], "请输入企业地址"),
        mail: vxRule(true, "Email", ["blur", "change"], "请输入个人邮箱"),
        creditCode: [
          {
            required: true,
            message: "请输入企业统一社会信用代码",
            trigger: ["blur", "change"],
          },
          {
            pattern: /^[0-9A-HJ-NPQRSTUWXY]{18}$/,
            required: true,
            message: "请输入有效的18位统一社会信用代码",
            trigger: ["blur", "change"],
          },
        ],
        idCard: [
          {
            required: true,
            message: "请输入法人身份证号",
            trigger: ["blur", "change"],
          },
          {
            required: true,
            message: "请输入正确的身份证号码",
            trigger: ["blur", "change"],
            pattern:
              /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
          },
        ],
        legalPersonName: [
          {
            required: true,
            message: "请输入法人姓名",
            trigger: ["blur", "change"],
          },
        ],
      }, // 表单验证
      Review: "",
      avatarArr: [],
      ReviewStr: "正在审核中，请过后查看审核结果。", //s
      rejectReason: "", //审核失败原因
      resData: {
        status: 0,
      }, //审核状态返回
    };
  },
  watch: {},
  // 组件初始化
  created() {
    // this.getSysDefaultUserImg();

    if (this.$route.query.key != "" && this.$route.query.key != undefined) {
      // 审核失败 重新申请时 拿到上次申请时传的数据，回显到表单中
      this.ruleForm.name = JSON.parse(this.$route.query.key).name;
      this.ruleForm.type = JSON.parse(this.$route.query.key).type;
      this.ruleForm.creditCode = JSON.parse(this.$route.query.key).creditCode;
      this.ruleForm.legalPersonName = JSON.parse(
        this.$route.query.key
      ).legalPersonName;
      this.ruleForm.idCard = JSON.parse(this.$route.query.key).idCard;
      this.ruleForm.companyRegisterAddress = JSON.parse(
        this.$route.query.key
      ).companyRegisterAddress;
      // this.ruleForm.logoImg = JSON.parse(this.$route.query.key).logoImg;
      this.ruleForm.mail = JSON.parse(this.$route.query.key).mail;
      this.ruleForm.useRecommendCode = JSON.parse(
        this.$route.query.key
      ).useRecommendCode;
    }
    // 审核状态
    this.Review = localStorage.getItem("Review");
    // if (this.Review == 1) {
    var data = {
      data: {
        mobile: localStorage.getItem("phone"),
      },
    };
    // 刷新页面获取审核状态
    companyRegisterAuditRecord(data).then((res) => {
      console.log(res, "res");
      this.resData = res.data.data;
      if (res.data.data && res.data.data.status == 1) {
        //审核成功
        this.Review = 1;
        this.ReviewStr = "账号审核已通过，请返回登录页进行登录。";
      } else if (res.data.data && res.data.data.status == 2) {
        //审核失败
        this.ruleForm.name = res.data.data.name;
        this.ruleForm.type = res.data.data.type;
        this.ruleForm.creditCode = res.data.data.creditCode;
        this.ruleForm.legalPersonName = res.data.data.legalPersonName;
        this.ruleForm.idCard = res.data.data.idCard;
        this.ruleForm.companyRegisterAddress =
          res.data.data.companyRegisterAddress;
        this.ruleForm.mail = res.data.data.mail;
        this.rejectReason = res.data.data.rejectReason;
        this.Review = 3;
      } else if (res.data.data && res.data.data.status == 0) {
        this.Review = 1;
      }
    });
    // }
  },
  // 组件实例挂载完毕
  mounted() {},
  //销毁事件
  destroyed() {
    clearInterval(this.timer);
    this.timer = null; // 重置定时器 id
    this.second = this.totalSecond; // 归位
  },
  // 组件方法
  methods: {
    ...mapActions([
      "SET_TOKEN",
      "SET_Interview",
      "SET_USERINFO",
      "SET_LOGINS",
      "SET_COMPANY_INFO",
    ]),
    // async getSysDefaultUserImg() {
    //   var data = {};
    //   // 调接口
    //   const res = await getSysDefaultUserImg(data);
    //   console.log(res);
    //   this.avatarArr = res.data;
    //   this.ruleForm.logoImg = res.data[0];
    // },

    // 上传头像
    handleAvatarTxUrl(val) {
      this.ruleForm.logoImg = val;
    },
    // 跳转
    handelSkipFirm() {
      this.$router.push({
        path: "/AllFirm",
        // query: { type: this.ruleForm.phone },
      });
    },
    // 性别选择
    handelType(item) {
      this.ruleForm.type = item.id;
    },
    // ----------------------------- postSendAuthCode (发送验证码接口) -----------------------------------
    async postSendAuthCode() {
      // 邮箱验证
      var data = {};
      data.data = { mail: this.ruleForm.mail, type: 1, authCodeBusiness: "7" };
      // 调接口
      const res = await postSendAuthCode(data);
      // 验证码发送成功
      if (res.code == 0) {
        // 验证码 发送成功 开启发送倒计时
        this.verify();
        this.$tool.PromptBox("success", "验证码已发送");
      } else {
        // 验证码发送失败
        // this.$tool.PromptBox("error", "验证码发送失败");
      }
    },

    // 点击 发送邮箱验证码
    Countdown(formName) {
      // 单独查看邮箱是否校验成功
      this.$refs[formName].validateField("mail", (errMsg) => {
        if (errMsg) {
          console.log("校验未通过");
          this.$tool.PromptBox("warning", "请输入正确的个人邮箱！");
        } else {
          console.log("校验通过");
          // 邮箱校验成功 点击获取验证码 才会往下进行
          // 调用 发送验证码倒计时  调用发送邮箱验证码接口
          this.postSendAuthCode();
        }
      });
    },
    // 发送验证码倒计时
    verify() {
      var that = this;
      // 点击发送验证码后延迟一秒 给that.sendNum加加 用于区分获取验证码 与 再次获取验证码
      setTimeout(function () {
        that.sendNum++;
        // 时间间隔
      }, 1000);
      // 当前目前没有定时器开着，且 totalSecond 和 second 一致 (秒数归位) 才可以倒计时
      if (!this.timer && this.second === this.totalSecond) {
        // 开启倒计时
        this.timer = setInterval(() => {
          this.second--;
          // 60秒倒计时结束 关闭定时器
          if (this.second <= 0) {
            clearInterval(this.timer);
            this.timer = null; // 重置定时器 id
            this.second = this.totalSecond; // 归位
          }
        }, 1000);
      }
    },
    // 点击注册   静态页面直接跳转首页
    handelSkipHomepage(formName) {
      console.log(this.ruleForm,1);
      // 表单校验
      //if (valid) 校验成功 调接口继续下一步
      //else 校验失败  return false;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleForm.mobile = localStorage.getItem("phone");
          var data = {
            data: this.ruleForm,
          };
          companyRegister(data).then((res) => {
            if (res.code == 0) {
              if (res.data.register == true && res.data.create != true) {
                // this.$router.push({ path: "/login", query: { key: "1" } });
                // this.Review = 1;
                // this.resData.status = 0;
                // this.$tool.PromptBox("success", "已提交审核");
                console.log('1111111111111')
                var data = {
                  data: {
                    mobile: localStorage.getItem("phone"),
                  },
                };
                // 刷新页面获取审核状态
                companyRegisterAuditRecord(data).then((res) => {
                  console.log(res, "res");
                  this.resData = res.data.data;
                  if (res.data.data && res.data.data.status == 1) {
                    //审核成功
                    this.Review = 1;
                    this.ReviewStr = "账号审核已通过，请返回登录页进行登录。";
                  } else if (res.data.data && res.data.data.status == 2) {
                    //审核失败
                    this.ruleForm.name = res.data.data.name;
                    this.ruleForm.type = res.data.data.type;
                    this.ruleForm.creditCode = res.data.data.creditCode;
                    this.ruleForm.legalPersonName =
                      res.data.data.legalPersonName;
                    this.ruleForm.idCard = res.data.data.idCard;
                    this.ruleForm.companyRegisterAddress =
                      res.data.data.companyRegisterAddress;
                    this.ruleForm.mail = res.data.data.mail;
                    this.rejectReason = res.data.data.rejectReason;
                    this.Review = 3;
                  } else if (res.data.data && res.data.data.status == 0) {
                    this.Review = 1;
                  }
                });
              } else {
                console.log(res.data, "注册成功");
                this.$store.commit("SET_TOKEN", res.data.token.token);
                this.$store.commit("SET_LOGINS", 1);
                this.$store.commit("SET_USERINFO", res.data.userInfo);
                // 移除LoginParty的localStorage操作，完全依赖Vuex
                this.$store.commit("SET_COMPANY_INFO", res.data.company);
                this.$router.push("/FirmHomePage");
                // 登录记录
                this.$tool.checkCompanyLogin(0);
                // this.$router.push({ path: "/login", query: { key: "1" } });
                this.$tool.PromptBox("success", "注册成功");
              }
            }
          });
        } else {
          return false;
        }
      });
    },
    handelReturn() {
      this.$router.push({ path: "/login", query: { key: "1" } });
    },
  },
};
</script>

<style scoped lang="less">
// 右侧 客服
.right_btn {
  width: 70px;
  background: #ffffff;
  position: fixed;
  right: 30px;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 90; /* below fixed header so avatar dropdown is not covered */
  padding: 5px 0;
}
/deep/.el-input__inner {
  width: 350px;
  height: 33px;
  border: 1px solid #409eff ;
}
/deep/.el-form-item__content {
  margin-left: 0 !important;
}
// 调提示文字位置
/deep/.firmSign .el-form-item__error {
  left: 200px;
}
/deep/.firmSign-left .el-form-item__error {
  left: 90px;
}
/deep/ .el-date-editor--date {
  width: 360px !important;
}

// 主体内容
.login-container {
  min-width: 1230px !important;
  height: 100%;
  min-height: 740px;
  display: flex;
  flex-direction: column;
  background: #0054cc;
  background-image: linear-gradient(
    90deg,
    rgba(97, 144, 232, 0.5) 0%,
    rgba(167, 191, 232, 0.5) 99%
  );
  // 中心白色区域
  .login-body {
    min-width: 1200px;
    min-height: 580px !important;
    font-size: 16px;
    margin: auto;
    background-color: #ffffff;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    z-index: 999;
    // 标题名
    .title {
      // width: 100%;
      height: 80px;
      line-height: 80px;
      // margin-top: 30px;
      font-family: FZLTCHJW--GB1-0;
      font-size: 18px;
      color: #001e50;
      font-weight: 600;
      // text-align: center;
      position: relative;
      padding-left: 40px;
      border-bottom: 1px solid #e7e7e7;
      p {
        width: 120px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        background: #317efc;
        border-radius: 5px;
        position: absolute;
        right: 30px;
        bottom: 20px;
        font-size: 16px;
        color: #ffffff;
        font-weight: 400;
      }
    }
    // 企业注册表单主体
    .firmSign-Body {
      width: 100%;
      min-height: 240px;
      margin-top: 40px;
      display: flex;
      justify-content: space-between;
      // border: 1px solid gold;
      .firmSign-BodyP {
        width: 100%;
        margin: auto;
        height: 320px;
        // line-height: 320px;
        // text-align: center;
        // color: #409eff ;
        // font-weight: 600;
        display: flex;
        flex-direction: column;
        img {
          width: 150px;
          height: 150px;
          margin: 0 auto;
          // border: 1px solid gold;
        }
        .Result-p {
          font-weight: bold;
          font-size: 14px;
          color: #333333;
          letter-spacing: 1px;
          text-align: center;
          font-style: normal;
          text-transform: none;
        }
        .Reason-p {
          min-width: 10px;
          max-width: 500px;
          line-height: 20px;
          font-weight: 400;
          font-size: 12px;
          color: #333333;
          text-align: center;
          font-style: normal;
          text-transform: none;
          margin: auto;
        }
      }
      // 分为左右两边的表单区
      .firmSign {
        width: 46%;
        height: 100%;
        .input-box {
          width: 100%;
          height: 35px;
          line-height: 35px;
          display: flex;
          // float: right;
          p {
            width: 300px;
            text-align: right;
            font-size: 14px;
            color: #333333;
          }
          .Selection {
            min-width: 350px;
            display: flex;
            p {
              width: 80px;
              height: 30px;
              line-height: 30px;
              background: #ffffff;
              border: 1px solid #409eff ;
              border-radius: 5px;
              font-size: 12px;
              color: #409eff ;
              text-align: center;
              margin-right: 8px;
            }
            .Select-p {
              background: rgba(97, 144, 232, 0.27);
            }
          }
        }
        .avatar_box {
          width: 80%;
          min-height: 35px;
          line-height: 35px;
          display: flex;
          position: relative;
          //border: 1px solid gold;
          p {
            width: 100px;
            text-align: left;
            font-size: 14px;
            color: #409eff ;
          }
          .Send-p {
            cursor: pointer;
            position: absolute;
            right: 25px;
            top: 3px;
            text-align: right;
            font-size: 12px;
          }
        }
      }
    }
  }
  // 底图
  .BaseMap {
    width: 100%;
    height: 300px;
    background-image: url("../../assets/imgs/img/beijinglou@2x.png");
    background-size: 100% 100%;
    position: absolute;
    bottom: 0;
  }
}
// 按钮区
.SignBtn {
  width: 100%;
  height: 40px;
  display: flex;
  margin-top: 60px;
  z-index: 99;
  .btn-box {
    width: 300px;
    height: 40px;
    margin: auto;
    display: flex;
    p {
      width: 120px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      margin: auto;
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #333333;
      font-weight: 400;
      background: #ffffff;
      box-sizing: border-box;
      border: 1px solid #999999;
      border-radius: 5px;
      cursor: pointer;
    }
    p:nth-child(2) {
      background: #409eff ;
      border-radius: 5px;
      color: #ffffff;
      border: none;
    }
  }
}
</style>
